/**
 * Phase 23-08: MembersTab replaced with an accounts redirect stub.
 * Members table dropped (migration 0054). The accounts page (/accounts) is the canonical view.
 * This component now shows a prompt to navigate to the Accounts page.
 */
import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useListAccounts } from "@workspace/api-client-react";
import { Skeleton } from "@/components/ui/skeleton";

interface Props {
  openCreate: boolean;
  setOpenCreate: (open: boolean) => void;
}

export function MembersTab({ openCreate: _openCreate, setOpenCreate: _setOpenCreate }: Props) {
  const [, navigate] = useLocation();
  const { data: accounts, isLoading } = useListAccounts({ status: "active" as const });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          Members are now managed as Accounts. Use the Accounts page to create and manage member accounts.
        </p>
        <Button onClick={() => navigate("/accounts")}>Go to Accounts</Button>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>
            Active Accounts{" "}
            <span className="text-muted-foreground font-normal text-sm">
              {accounts ? `(${accounts.length})` : ""}
            </span>
          </CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <div className="space-y-2">
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} className="h-8 w-full" />
              ))}
            </div>
          ) : (
            <p className="text-sm text-muted-foreground text-center py-6">
              {accounts?.length ?? 0} active accounts.{" "}
              <button className="underline" onClick={() => navigate("/accounts")}>
                View all accounts
              </button>
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
